if (!customElements.get('urbansales-collection-list')) {
    class CollectionList extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.collection-list__items',
          pagination: '.swiper-pagination',
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };
  
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
  
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.space = parseInt(this.dataset.space);
        this.spaceMb = parseInt(this.dataset.spaceMb);
        this.row = parseInt(this.dataset.row);
        this.rowMB = parseInt(this.dataset.rowMb);
  
        this.sliderInstance = false;
  
        if (!this.enableSlider) return;
  
        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
      }
  
      init() {
        if (FoxTheme.config.mqlMobile && this.rowMB == 1) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }
  
      initSlider() {
  
        // const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        // const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
        // const space = parseFloat(columnGap.replace('rem', '')) * 10;
        if (parseInt(this.items) == 4) {
          this.items = 4
        }
        // const sliderOptions = {
        //   modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
        //   slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
        //   spaceBetween: this.spaceMb,
        //   grid: {
        //     rows: 2,
        //     fill: 'row',
        //   },
        //   navigation: {
        //     nextEl: this.section.querySelector(this.selectors.nextEl),
        //     prevEl: this.section.querySelector(this.selectors.prevEl),
        //   },
        //   pagination: false,
        //   breakpoints: {
        //     1280: {
        //       slidesPerView: this.items,
        //       spaceBetween: this.space
        //     },
        //   },
        //   loop: false,
        //   threshold: 2,
        // };
  
        // if (typeof this.sliderInstance !== 'object') {
        //   this.classList.add(this.classes.swiper);
        //   this.sliderWrapper.classList.remove(this.classes.grid);
        //   this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        //   this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        //   this.sliderInstance.init();
  
        //   const focusableElements = FoxTheme.a11y.getFocusableElements(this);
  
        //   focusableElements.forEach((element) => {
        //     element.addEventListener('focusin', () => {
        //       const slide = element.closest('.swiper-slide');
        //       this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
        //     });
        //   });
        // }
  
        // if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        //   document.addEventListener('shopify:block:select', (e) => {
        //     if (e.detail.sectionId != this.sectionId) return;
        //     let { target } = e;
        //     const index = Number(target.dataset.index);
  
        //     this.sliderInstance.slider.slideToLoop(index);
        //   });
        // }
  
        let loop = false;
        if (this.row == 1) {
          loop = true;
        }
  
        const swiper = new Swiper(this, {
          slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
          spaceBetween: this.spaceMb,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          grid: {
            rows: this.rowMB,
            fill: 'row',
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: this.space,
              loop: loop,
              grid: {
                rows: this.row,
                fill: 'row',
              },
            },
            1280: {
              slidesPerView: this.items,
              spaceBetween: this.space,
              loop: loop,
              grid: {
                rows: this.row,
                fill: 'row',
              },
            },
          },
          loop: false,
        });
      }
  
      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
    customElements.define('urbansales-collection-list', CollectionList);
  }
  